import React from "react";
import PropTypes from "prop-types";

const PRIMARY = "#4A2CF5";
const LAVENDER = "#775EFF";
const WASH = "#F6F4FF";

function Frame({ size, label, children }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={label}
    >
      <circle cx="60" cy="60" r="54" fill={WASH} />
      {children}
    </svg>
  );
}

Frame.propTypes = {
  size: PropTypes.number,
  label: PropTypes.string,
  children: PropTypes.node,
};

export function MetricsEmptyIllustration({ size = 96 }) {
  return (
    <Frame size={size} label="Metrics illustration">
      <rect x="28" y="34" width="64" height="48" rx="8" fill="#fff" stroke={PRIMARY} strokeWidth="2" />
      <path
        d="M36 66l12-14 10 8 16-18"
        stroke={PRIMARY}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <circle cx="74" cy="42" r="3.5" fill={LAVENDER} />
      <rect x="36" y="72" width="8" height="4" rx="1" fill={LAVENDER} opacity="0.45" />
      <rect x="48" y="72" width="8" height="4" rx="1" fill={LAVENDER} opacity="0.7" />
      <rect x="60" y="72" width="8" height="4" rx="1" fill={PRIMARY} opacity="0.55" />
    </Frame>
  );
}

MetricsEmptyIllustration.propTypes = { size: PropTypes.number };

export function DetailsEmptyIllustration({ size = 96 }) {
  return (
    <Frame size={size} label="Details illustration">
      <rect x="34" y="28" width="52" height="64" rx="8" fill="#fff" stroke={PRIMARY} strokeWidth="2" />
      <rect x="42" y="40" width="28" height="3.5" rx="1.5" fill={PRIMARY} opacity="0.75" />
      <rect x="42" y="50" width="36" height="3" rx="1.5" fill={LAVENDER} opacity="0.45" />
      <rect x="42" y="58" width="32" height="3" rx="1.5" fill={LAVENDER} opacity="0.35" />
      <rect x="42" y="66" width="24" height="3" rx="1.5" fill={LAVENDER} opacity="0.3" />
      <circle cx="72" cy="78" r="10" fill={WASH} stroke={PRIMARY} strokeWidth="2" />
      <path d="M72 74v8M68 78h8" stroke={PRIMARY} strokeWidth="2" strokeLinecap="round" />
    </Frame>
  );
}

DetailsEmptyIllustration.propTypes = { size: PropTypes.number };

export function LocationEmptyIllustration({ size = 96 }) {
  return (
    <Frame size={size} label="Location illustration">
      <path
        d="M60 28c-12 0-22 9.5-22 22 0 16 22 38 22 38s22-22 22-38c0-12.5-10-22-22-22z"
        fill="#fff"
        stroke={PRIMARY}
        strokeWidth="2.5"
      />
      <circle cx="60" cy="50" r="8" fill={WASH} stroke={LAVENDER} strokeWidth="2" />
      <rect x="34" y="86" width="52" height="6" rx="3" fill={LAVENDER} opacity="0.25" />
    </Frame>
  );
}

LocationEmptyIllustration.propTypes = { size: PropTypes.number };

export function PeopleEmptyIllustration({ size = 96 }) {
  return (
    <Frame size={size} label="People illustration">
      <circle cx="48" cy="42" r="10" fill="#fff" stroke={PRIMARY} strokeWidth="2" />
      <path
        d="M30 78c0-10 8-16 18-16s18 6 18 16"
        stroke={PRIMARY}
        strokeWidth="2.5"
        strokeLinecap="round"
        fill="none"
      />
      <circle cx="78" cy="46" r="8" fill="#fff" stroke={LAVENDER} strokeWidth="2" />
      <path
        d="M64 78c1-8 7-13 14-13 8 0 14 5 15 13"
        stroke={LAVENDER}
        strokeWidth="2.5"
        strokeLinecap="round"
        fill="none"
      />
    </Frame>
  );
}

PeopleEmptyIllustration.propTypes = { size: PropTypes.number };

export function SimilarEmptyIllustration({ size = 96 }) {
  return (
    <Frame size={size} label="Similar companies illustration">
      <circle cx="44" cy="52" r="18" fill="#fff" stroke={PRIMARY} strokeWidth="2.5" />
      <circle cx="76" cy="52" r="18" fill="#fff" stroke={LAVENDER} strokeWidth="2.5" />
      <circle cx="60" cy="52" r="8" fill={WASH} stroke={PRIMARY} strokeWidth="1.5" />
      <rect x="40" y="80" width="40" height="5" rx="2.5" fill={LAVENDER} opacity="0.3" />
    </Frame>
  );
}

SimilarEmptyIllustration.propTypes = { size: PropTypes.number };
